import React from 'react'
import { Container } from './styles'

export default function CardComponent({ children }) {
  return <Container>{children}</Container>
}